"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.IfAnonymous = exports.IfNotAnonymous = void 0;

var _isAnonymousUser = _interopRequireDefault(require("../../common/utils/isAnonymousUser")),
    IfNotAnonymous = function IfNotAnonymous(a) {
  var b = a.children;
  return (0, _isAnonymousUser["default"])() ? null : b();
};

exports.IfNotAnonymous = IfNotAnonymous;

var IfAnonymous = function IfAnonymous(a) {
  var b = a.children;
  return (0, _isAnonymousUser["default"])() ? b() : null;
};

exports.IfAnonymous = IfAnonymous;